//
"use strict";

import 'mapbox-gl/dist/mapbox-gl.css';
import mapboxgl from '!mapbox-gl'; // eslint-disable-line import/no-webpack-loader-syntax
mapboxgl.accessToken = 'pk.eyJ1IjoiYnJhd3VyIiwiYSI6ImNpbjV1ZmJjMzAwdnB2OWx5ZnBjN2w0Z2YifQ.kmnnV98Hh6xLwh-junvVfA'; //ebb

$(() => {
  let map;

  const getPopup = (property) => {
    const container = $("<div class='ebb-property-map-popup'><div>");
    const texte = $(property).find(".ebb-property-text-container");
    container.append($("<strong>" + texte.find("h2").text() + "</strong>"));
    container.append($("<hr />"));
    container.append(texte.find(".ebb-property-address").clone());
    container.append(texte.find(".ebb-property-facts").clone());
    container.append(texte.find(".ebb-property-more").clone().addClass("mt-2").removeClass("justify-content-end").addClass("justify-content-center"));
    return container.html();
  }

  const loadPropertiesForMap = () => {
    const result = [];
    $("[data-js-property-list] [data-props]")
      .filter(":not(.d-none-price-filter)")
      .filter(":not(.d-none-area-filter)")
      .filter(":not(.d-none-type-filter)")
      .each((i, property) => {
        const raw = JSON.parse(property.getAttribute("data-props"));
        raw.idx = property.getAttribute("data-c-idx");
        result.push(
          {
            'type': 'Feature',
            'geometry': {
              'type': 'Point',
              'coordinates': [raw.longitude, raw.latitude],
            },
            'properties': {
              'title': raw.idx,
              'description': getPopup(property),
              'icon': 'custom-marker'
            }
          }
        )
      });
    updateResultCount(result.length);
    return result;
  }

  const getBounds = (collection) => {
    const result = [];
    const features = collection.data.features;
    let latMax = Number.MIN_VALUE;
    let latMin = Number.MAX_VALUE;
    let lngMax = Number.MIN_VALUE;
    let lngMin = Number.MAX_VALUE;
    if (Array.isArray(features)) {
      features.forEach((feature) => {
        const lng = feature.geometry.coordinates[0];
        const lat = feature.geometry.coordinates[1];
        latMax = Math.max(latMax, lat);
        latMin = Math.min(latMin, lat);
        lngMax = Math.max(lngMax, lng);
        lngMin = Math.min(lngMin, lng);
      });
    }
    return [[lngMin - 0.005, latMin - 0.008], [lngMax + 0.005, latMax + 0.008]];
  };

  const updateResultCount = (count) => {
    const bar = $("[data-js-property-list-result]");
    bar.find(".count").html(count ? count : "");
    if (count === 0) {
      bar.find(".none").removeClass("d-none");
      bar.find(".single").addClass("d-none");
      bar.find(".multi").addClass("d-none");
    } else if (count === 1) {
      bar.find(".none").addClass("d-none");
      bar.find(".single").removeClass("d-none");
      bar.find(".multi").addClass("d-none");
    } else {
      bar.find(".none").addClass("d-none");
      bar.find(".single").addClass("d-none");
      bar.find(".multi").removeClass("d-none");
    }
  }

  const getData = () => {
    return {
      'type': 'geojson',
      'data': {
        'type': 'FeatureCollection',
        'features': loadPropertiesForMap()
      },
      cluster: true,
      clusterMaxZoom: 150,
      clusterRadius: 35
    };
  }

  const list = $("[data-js-property-list]");
  if (list.length > 0) {
    $("[data-js-mapbox-property]").each((index, mapContainer) => {
      map = new mapboxgl.Map({
        container: mapContainer, // container ID
        style: 'mapbox://styles/mapbox/light-v10', // style URL
        center: [7.206999728269411, 53.36767971903283], // starting position [lng, lat]
        zoom: 12 // starting zoom
      });
      map.scrollZoom.disable();
      map.addControl(new mapboxgl.NavigationControl());
      if ($("[data-js-property-list] [data-props]").length > 0) {
        const popups = [];
        window['updateMap'] = (update = false) => {
          if (update) {
            map.removeLayer('places');
            map.removeLayer('cluster-circle');
            map.removeLayer('cluster-count');
            map.removeSource('places');
            popups.forEach((popup, i) => {
              popup.remove();
            })
          }
          const collection = getData();
          map.addSource('places', collection);
          map.fitBounds(getBounds(collection));
          // Add a layer showing the places.

          map.addLayer({
            'id': 'places',
            'type': 'symbol',
            'source': 'places',
            'layout': {
              'icon-image': '{icon}',
              'text-field': ['get', 'title'],
              'text-font': [
                'Open Sans Semibold',
                'Arial Unicode MS Bold'
              ],
              'text-offset': [0, -1.25],
              'text-anchor': 'top'
            },
            'paint': {
              'text-color': "#FFFFFF"
            }
          });

          map.addLayer({
            id: 'cluster-circle',
            type: 'circle',
            source: 'places',
            filter: ['has', 'point_count'],
            paint: {
              'circle-color': '#E30614',
              'circle-radius': 28,
              'circle-stroke-width': 2,
              'circle-stroke-color': '#fff'
            }
          });

          map.addLayer({
            id: 'cluster-count',
            type: 'symbol',
            source: 'places',
            filter: ['has', 'point_count'],
            layout: {
              'text-field': '{point_count_abbreviated}',
              'text-font': ['Open Sans Semibold', 'Arial Unicode MS Bold'],
              'text-size': 18,
            },
            'paint': {
              'text-color': "#FFFFFF"
            }
          });

          if (!update) {
            // When a click event occurs on a feature in the places layer, open a popup at the
            // location of the feature, with description HTML from its properties.
            map.on('click', 'places', (e) => {
              // Copy coordinates array.
              const coordinates = e.features[0].geometry.coordinates.slice();
              const description = e.features[0].properties.description;

              // Ensure that if the map is zoomed out such that multiple
              // copies of the feature are visible, the popup appears
              // over the copy being pointed to.
              while (Math.abs(e.lngLat.lng - coordinates[0]) > 180) {
                coordinates[0] += e.lngLat.lng > coordinates[0] ? 360 : -360;
              }

              const popup = new mapboxgl.Popup()
                .setLngLat(coordinates)
                .setHTML(description)
                .addTo(map);
              popups.push(popup);
            });
          }

          // Change the cursor to a pointer when the mouse is over the places layer.
          map.on('mouseenter', 'places', () => {
            map.getCanvas().style.cursor = 'pointer';
          });

          // Change it back to a pointer when it leaves.
          map.on('mouseleave', 'places', () => {
            map.getCanvas().style.cursor = '';
          });
        }

        map.on('load', () => {
          map.loadImage('/typo3conf/ext/bw_ebb_template/Resources/Public/Images/mapbox/mapbox-marker.png',
            (error, image) => {
              map.addImage('custom-marker', image);
              window.updateMap();
            });
        });
      } else {
        updateResultCount(0);
        $("[data-js-properties-sorting]").prop('disabled', 'disabled');
        $("[data-js-properties-empty]").first().removeClass("d-none");
      }
    });
  }

  const detail = $("[data-js-property-detail]");
  if (list.length === 0 && detail.length === 1) {
    const lng = detail.attr("data-js-lng");
    const lat = detail.attr("data-js-lat");

    $("[data-js-mapbox-property]").each((index, mapContainer) => {
      map = new mapboxgl.Map({
        container: mapContainer, // container ID
        style: 'mapbox://styles/mapbox/light-v10', // style URL
        center: [lng, lat], // starting position [lng, lat]
        zoom: 13.3 // starting zoom
      });
      map.scrollZoom.disable();
      map.addControl(new mapboxgl.NavigationControl());

      if (typeof (lng) != "undefined" && typeof (lat) != "undefined") {
        map.on('load', () => {
          map.loadImage('/typo3conf/ext/bw_ebb_template/Resources/Public/Images/mapbox/mapbox-marker-single.png',
            (error, image) => {
              map.addImage('custom-marker', image);
              const collection = {
                'type': 'geojson',
                'data': {
                  'type': 'FeatureCollection',
                  'features': [
                    {
                      'type': 'Feature',
                      'geometry': {
                        'type': 'Point',
                        'coordinates': [lng, lat],
                      },
                      'properties': {
                        'icon': 'custom-marker'
                      }
                    }
                  ]
                }
              };
              map.addSource('places', collection);

              // Add a layer showing the places.
              map.addLayer({
                'id': 'places',
                'type': 'symbol',
                'source': 'places',
                'layout': {
                  'icon-image': '{icon}',
                }
              });

              // Change the cursor to a pointer when the mouse is over the places layer.
              map.on('mouseenter', 'places', () => {
                map.getCanvas().style.cursor = 'pointer';
              });

              // Change it back to a pointer when it leaves.
              map.on('mouseleave', 'places', () => {
                map.getCanvas().style.cursor = '';
              });
            });
        });
      }
    });
  }
});
